export const constant = [
  'tmrApiPrefix',
  process.env.tmrEnv.tmrApiPrefix ?? 'benetton-tmr-api',
]
